// extracted by mini-css-extract-plugin
export default {"mpQuerySamplingCta":"mp-query-sampling-cta__eNczcS0E"};